"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var enums_1 = require("@ikea-aoa/enums");
var ServiceFetch_1 = __importDefault(require("../../utilities/ServiceFetch"));
/**
 * This class is used for sending a saved planner configuration to a user through email or sms.
 */
var DexfNotificationService = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.endpoint Endpoint.
     * @param options.dexfApiKey DEXF API key.
     */
    function DexfNotificationService(options) {
        this.endpoint = null;
        this.dexfApiKey = null;
        this.endpoint = options.endpoint;
        this.dexfApiKey = options.dexfApiKey;
    }
    /**
     * Sends an email with a configuration to a user.
     *
     * @param options Options.
     * @param options.vpcCode Vpc code.
     * @param options.type Email or Sms.
     * @param options.contact Email address or phone number.
     * @param options.linkType Destination for the link. Planner or pickinglist.
     * @param options.storeId Store ID. Configurable for pickinglist.
     * @returns Sent notification status.
     */
    DexfNotificationService.prototype.sendNotification = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var preparedMessageUrl, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.prepareMessage(options.vpcCode, options.type, options.linkType, options.storeId)];
                    case 1:
                        preparedMessageUrl = _a.sent();
                        return [4 /*yield*/, ServiceFetch_1.default.json(preparedMessageUrl, {
                                credentials: 'same-origin',
                                method: 'POST',
                                headers: this.getHeaders(),
                                body: this.getBody(options.contact)
                            })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response['jobId'] !== undefined ? true : false];
                }
            });
        });
    };
    /**
     * Prepares message template and returns prepared reference object.
     *
     * @param vpcCode VpcCode ex '34WY5'.
     * @param type Type ex 'email' or 'sms'.
     * @param linkType Destination for the link. Planner or pickinglist.
     * @param storeId Store ID. Configurable for pickinglist.
     * @returns Prepared message url.
     */
    DexfNotificationService.prototype.prepareMessage = function (vpcCode, type, linkType, storeId) {
        return __awaiter(this, void 0, void 0, function () {
            var baseUrl, url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        baseUrl = this.endpoint;
                        url = baseUrl + "/" + vpcCode + "/prepare?type=" + type + "&linkType=" + linkType;
                        if (storeId && enums_1.NotificationLinkTypeEnum.pickinglist === linkType) {
                            url += "&storeCode=" + storeId;
                        }
                        return [4 /*yield*/, ServiceFetch_1.default.json(url, {
                                credentials: 'same-origin',
                                method: 'GET',
                                headers: this.getHeaders()
                            })];
                    case 1:
                        response = _a.sent();
                        if (response['_links']) {
                            return [2 /*return*/, decodeURI(response['_links']['send']['href'])];
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    /**
     * Returns body for notification.
     *
     * @param contact Email address or phone number.
     * @returns Stringified body.
     */
    DexfNotificationService.prototype.getBody = function (contact) {
        return JSON.stringify({
            to: contact
        });
    };
    /**
     * Returns headers.
     *
     * @returns Headers.
     */
    DexfNotificationService.prototype.getHeaders = function () {
        return {
            'dexf-api-key': this.dexfApiKey,
            'content-type': 'application/json'
        };
    };
    return DexfNotificationService;
}());
exports.default = DexfNotificationService;
//# sourceMappingURL=DexfNotificationService.js.map